import React from 'react';

import colors from '../sl-colors';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

export default function ArrowUp({ color = colors.gray['600'], ...props }: Props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12ZM12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM12.5303 7.46964C12.3897 7.32899 12.1989 7.24997 12 7.24997C11.8011 7.24997 11.6103 7.32899 11.4697 7.46964L8.46968 10.4696C8.17679 10.7625 8.17679 11.2374 8.46968 11.5303C8.76257 11.8232 9.23745 11.8232 9.53034 11.5303L11.25 9.81063V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V9.81063L14.4697 11.5303C14.7626 11.8232 15.2374 11.8232 15.5303 11.5303C15.8232 11.2374 15.8232 10.7625 15.5303 10.4696L12.5303 7.46964Z"
        fill={color}
      />
    </svg>
  );
}
